import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CartItemsExpiredNotification from 'base/components/CartItemsExpiredNotification';
import { editCart } from 'cart/actions';
import { closeNotificationModal } from 'base/actions/notificationModals';

class CartItemsExpiredNotificationContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired
  };

  handlePrimaryCta = () => {
    const { dispatch } = this.props;
    dispatch(editCart({ clear_cart: true }));
    dispatch(closeNotificationModal());
  };

  render() {
    return (
      <CartItemsExpiredNotification
        handlePrimaryCta={this.handlePrimaryCta}
        closeModal={this.props.closeModal}
      />
    );
  }
}

export default connect()(CartItemsExpiredNotificationContainer);
